module.exports = __webpack_public_path__ + "static/media/ZillaSlab-SemiBoldItalic.dd86a927.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/ZillaSlab-SemiBoldItalic.eot
// module id = 2924
// module chunks = 71